import { Box, Button, FormGroup, Grid, Modal, Typography } from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { apiErrorMessage } from "../../helper/apiError";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import LeftSideArrow from "../../Icon/LeftSideArrow";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
} from "../../Redux/action/ApplicationAction";
import {
  AddStudentNotesService,
  DeleteStudentNotesService,
  DeleteStudentReminderService,
} from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import CustomButton from "../button/button";
import { Form, Formik } from "formik";
import axios from "axios";
import { basicurl } from "../../Redux/ServiceUrl/url";
import Previews from "../dropzone/Mydropzone";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "100%", xs: "100%", md: "50%", lg: "50%" },
  height: "40vh",
  overflow: "auto",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "2px solid grey",
  boxShadow: 24,
  p: 4,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};

export const BulkUploadModal = ({ open, handleClose, url, action }) => {
  const dispatch = useDispatch();
  // console.log(open);

  return (
    <>
      {" "}
      <Modal
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography align="right" onClick={() => handleClose()}>
            <Crossicon width={"20"} height={"20"} />
          </Typography>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.large}
            color={ThemeColor.BLACK}
            align="center"
          >
            Bulk Upload
          </Typography>
          <Formik
            className="w-100"
            initialValues={{
              file: null,
            }}
            onSubmit={async (values, { resetForm }) => {
              if (!values.file) {
                alert("No file selected");
                return;
              }

              const formData = new FormData();
              formData.append("file", values.file);
              console.log(formData);
              await axios
                .post(`${basicurl}/${url}`, formData, {
                  headers: {
                    Authorization: `Bearer ${window.sessionStorage.getItem(
                      "user_token"
                    )}`,
                  },
                })
                .then((res) => {
                  if (res.status === 200) {
                    action();
                    handleClose();
                    dispatch(showSnackbar(res.data.message, "success"));
                  }
                })
                .catch((e) => {
                  dispatch(showSnackbar(apiErrorMessage(e), "error"));
                });
            }}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              touched,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form className="w-100">
                <FormGroup
                  style={{}}
                  className="w-100 d-flex align-items-center justify-content-center"
                >
                  {/* <Previews
                      initialValue={values?.file}
                      handleMydropzoneFile={(updatedFiles) => {
                        //(updatedFiles);
                        setFieldValue("file", updatedFiles);
                      }}
                      multiple={"no"}
                      height={50}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.file}
                        </Typography>
                      }
                    /> */}
                  <Button
                    variant="contained"
                    className="w-50 mt-3"
                    component="label"
                  >
                    Upload Excel
                    <input
                      type="file"
                      hidden
                      accept=".xlsx,.xls"
                      onChange={(e) => {
                        const file = e.currentTarget.files?.[0];

                        if (
                          file &&
                          (file.name.endsWith(".xlsx") ||
                            file.name.endsWith(".xls"))
                        ) {
                          setFieldValue("file", file);
                        } else {
                          alert(
                            "Please select a valid Excel file (.xlsx or .xls)"
                          );
                          e.target.value = ""; // Reset the input
                          setFieldValue("file", null);
                        }
                      }}
                    />
                  </Button>

                  {values.file && (
                    <Typography variant="body2">
                      Selected: {values.file.name}
                    </Typography>
                  )}
                  <div className="px-3 mt-3">
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                      // loading={formLoading}
                      padding={"0px"}
                      // onClick={handleClick}
                    >
                      Upload
                    </CustomButton>
                  </div>
                </FormGroup>

                <div className="d-flex justify-content-center align-items-center h-100 w-100 mt-5"></div>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    </>
  );
};
